import {
  BookingRequestsStatus,
  PatchActiveBookingRequestsDto
} from "../../../BookingRequest/typings/booking-requests.types";
import { DetailedServiceBookingData } from "../Domain/RemoteOrderRequests.types";
import { resolveOrderRequestBookingType } from "./resolveOrderRequestBookingType.function";

/** PATCH `/booking-approval/status` for the parent booking; no-op if detail is missing. */
export async function patchAssociatedBookingApproval(
  detailData: DetailedServiceBookingData | null,
  patchBookingRequest: (dto: PatchActiveBookingRequestsDto) => Promise<void>
): Promise<void> {
  if (!detailData) {
    return;
  }

  await patchBookingRequest({
    status: BookingRequestsStatus.APPROVED,
    bookingData: [
      {
        bookingId: Number(detailData.bookingId),
        bookingType: resolveOrderRequestBookingType(detailData.placeOrZoneType)
      }
    ]
  });
}
